import { mirrorX, softShade } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, Pivot, R, Segments, SharedColors } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
export class BeamBalance {
    render(appearance) {
        const { tilt, size } = appearance;
        const plateWidth = size / 2.5 - 8; // (120)
        const height = size; // (320)
        const width = size / 2 + 126; // (286)
        const halfWidth = width / 2; // (143)
        const base = Shape.Rectangle(R(0, height, width + plateWidth / 2 + 20, 20, Pivot.CENTER), 2.0)
            .withStroke("default", SharedColors.stroke)
            .withFill("#878c91");
        const pillar = Shape.Rectangle(R(0, 0, 25, height, Pivot.TOP_CENTER))
            .withGradientFill("right", Gradients.cylinder("#aaaaaa".color()))
            .withStroke("default", SharedColors.stroke);
        const beam = new Path(Segments([[halfWidth - 64, -24], [-10, -8]], [[halfWidth - 31, -3], [-6, 0]], [[halfWidth, -3], , [2, 0]], [[halfWidth, 8], [3, 0]], [[halfWidth - 30, 8], , [-10, 0]], [[halfWidth - 70, -10], [7, -2]], [[3, 3]], [[0, 15]])).close().withStroke("default", SharedColors.stroke).withGradientFill("right-down", Gradients.cylinder("#777777".color()));
        mirrorX(beam);
        beam.rotate(tilt, P(0, 0));
        const plate = Shape.Rectangle(R(0, height - 70, plateWidth, 10, Pivot.CENTER), 2.0)
            .withGradientFill("right", Gradients.cylinder("#cccccc".color()))
            .withStroke("thin", "#888888");
        const wire = new Path(Segments([[-plateWidth / 2, height - 70]], [[-plateWidth / 2, plateWidth * 0.6]], [[0, 0]], [[plateWidth / 2, plateWidth * 0.6]], [[plateWidth / 2, height - 70]])).withStroke("thin", "#888888");
        const scaleL = new Group([wire, plate]);
        scaleL.pivot = P(0, 0);
        scaleL.position = P(-halfWidth + 18, 2).rotate(tilt, P(0, 0));
        const scaleR = scaleL.clone();
        scaleR.position = P(halfWidth - 18, 2).rotate(tilt, P(0, 0));
        // add markings.
        const line_0 = new Path.Line(P(0, 23), P(0, 30)).withStroke(1.0, "#555555");
        const line_1 = line_0.clone();
        line_1.rotate(-10, P(0, 0));
        const line_2 = line_0.clone();
        line_2.rotate(10, P(0, 0));
        const graphic = new Group([
            pillar,
            softShade("full", null, P(0, -20), P(0, 25), "#777777", 10.0),
            base, scaleL, scaleR, beam, line_0, line_1, line_2
        ]);
        return {
            graphic,
            hitShape: [
                base.bounds.toShape(),
                beam.bounds.toShape(),
                pillar.bounds.toShape(),
                plate.bounds.toShape(),
                scaleR.children[1].bounds.toShape(),
            ],
            pivot: pillar.bounds.center,
            snapping: [
                base.placeable(),
                scaleL.children[1].topEdgeAsPlaceableSurface(),
                scaleR.children[1].topEdgeAsPlaceableSurface(),
            ]
        };
    }
}
BeamBalance.properties = {
    label: "Beam Balance",
    defaultAppearance: {
        tilt: 0,
        size: 240
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 180, max: 320,
        },
        {
            spec: "slider", key: "tilt", label: "Tilt",
            min: -10, max: 10, step: 0.1,
        }
    ],
};
